import { createContext, MutableRefObject, useContext } from 'react'

type SealedParamsContextValue = {
  paramsRef: MutableRefObject<Record<string, string>>
  /**
   * Compartilhado entre toda instancia de `useSealedSearchParams` (o hook e
   * chamado de forma independente em `useFilters`, `useInitFilters` e
   * `AccreditedEstablishmentsView`). Um contador por instancia so serializa
   * chamadas feitas pelo mesmo hook; duas instancias diferentes escrevendo ao
   * mesmo tempo (ex: troca de filtro e abertura de drawer) continuariam
   * correndo entre si sem um relogio compartilhado.
   */
  latestRequestIdRef: MutableRefObject<number>
}

/*
 * Sem provider, undefined forca um erro visivel na hora do uso errado, em vez
 * de um objeto mutavel compartilhado silenciosamente entre todo mundo que
 * esquecer de renderizar dentro do AccreditedEstablishmentsProvider -
 * inclusive, no servidor, entre requisicoes de usuarios diferentes.
 */
const SealedParamsContext = createContext<SealedParamsContextValue | undefined>(
  undefined
)

const useSealedParamsContext = () => {
  const context = useContext(SealedParamsContext)

  if (!context) {
    throw new Error(
      'useSealedParamsContext must be used within a SealedParamsContext.Provider'
    )
  }

  return context
}

export { SealedParamsContext, useSealedParamsContext }
export type { SealedParamsContextValue }
